import metadata from './seo-data.json';
import homepageSchema from './seo-schema.json';

export function updateSeo(pathname) {
  const info = metadata[pathname];
  const base = 'https://betaris-glanzwerk.de';
  document.title = info?.title || 'Seite nicht gefunden | betaris Glanzwerk';
  const setMeta = (attribute, name, content) => {
    let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
    if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, name); document.head.appendChild(element); }
    element.setAttribute('content', content);
  };
  setMeta('name', 'description', info?.description || 'Die angeforderte Seite wurde nicht gefunden.');
  setMeta('name', 'robots', info ? 'index,follow' : 'noindex,follow');
  setMeta('property', 'og:title', document.title);
  setMeta('property', 'og:description', info?.description || 'Die angeforderte Seite wurde nicht gefunden.');
  setMeta('property', 'og:url', base + pathname);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (info) {
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = base + pathname;
  } else { canonical?.remove(); }
  let schema = document.getElementById('betaris-schema');
  if (info) {
    if (!schema) { schema = document.createElement('script'); schema.id = 'betaris-schema'; schema.type = 'application/ld+json'; document.head.appendChild(schema); }
    schema.textContent = JSON.stringify(pathname === '/' ? homepageSchema : {
      '@context':'https://schema.org', '@type':'BreadcrumbList', itemListElement:[
        {'@type':'ListItem',position:1,name:'Startseite',item:base+'/'},
        {'@type':'ListItem',position:2,name:pathname === '/impressum' ? 'Impressum' : 'Datenschutzhinweise',item:base+pathname}
      ]
    });
  } else { schema?.remove(); }
}
